import { render } from "./DeklarasiSehat.vue?vue&type=template&id=6dce4ec1&scoped=true"
import script from "./DeklarasiSehat.vue?vue&type=script&lang=js"
export * from "./DeklarasiSehat.vue?vue&type=script&lang=js"

import "./DeklarasiSehat.vue?vue&type=style&index=0&id=6dce4ec1&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dce4ec1"]])

export default __exports__